import { DmsConfig, SignType, Font, OpStatus } from 'NSwag/ServerClient/Client.nswag';
import { DefaultFontWidth, DefaultFontHeight } from 'DataLibrary/Dms/MultiMsgConstants';

export interface ISignDimensions {
    height: number,
    lines: number,
    col: number,
    width: number
}

export const getSignDimensions = (dmsConfig?: DmsConfig, font?: Font | null): ISignDimensions => {
    let result: ISignDimensions;

    let fontWidth = font ? font.width : DefaultFontWidth;

    if (dmsConfig) {
        let fontHeight = font
            ? font.height + font.lineSpacing
            : DefaultFontHeight;
        // Calculate dimensions based on sign type.
        if (dmsConfig.signType === SignType.FullMatrix) {
            result = {
                height: dmsConfig.numLines,
                // Calculate number of lines based on char height
                lines: Math.floor(dmsConfig.numLines / fontHeight),
                // calculate width based on char width.
                width: dmsConfig.numColumns,
                col: dmsConfig.numColumns / fontWidth
            }
        } else if (dmsConfig.signType === SignType.LineMatrix) {
            result = {
                height: dmsConfig.numLines * fontHeight,
                // Lines is number given on Line matrix.
                lines: dmsConfig.numLines,
                // calculate width based on char width.
                width: dmsConfig.numColumns,
                col: dmsConfig.numColumns / fontWidth
            }
        } else {
            result = {
                height: dmsConfig.numLines * fontHeight,
                // Lines is number given on Char signs.
                lines: dmsConfig!.numLines,
                // Char spacing does not need to be considered for Char signs.
                width: dmsConfig!.numColumns * DefaultFontWidth,
                col: dmsConfig.numColumns
            }
        }
    } else {
        // Default in case we do not have config or font
        result = {
            height: 3 * DefaultFontHeight,
            lines: 3,
            width: 15 * DefaultFontWidth,
            col: 15
        }
    }

    return result;
}

/**
 * A list of all supported tags in a regexp parseable format.
 */
const supportedTags: string[] = ['\[fo[0-9]\]', '\[nl\]', '\[np\]', '\[jl[0-9]\]', '\[pt[0-9]+o[0-9]+\]', '\[img[0-9]+\]'];

/**
 * Filters out unsupported tags from a multi-message string.
 * @param multiMessage - The current multi-message string that is being tag validated.
 */
export const areTagsSupported = (multiMessage: string) => {
    let tagRegex = /\[.*\]/g;
    const supportedTagExpression = new RegExp(supportedTags.join('|'), 'i');
    const fontTagExpression = new RegExp(supportedTags[0], 'g');
    let supported = true;
    let i: number;

    if (multiMessage != null) {
        //Check for more than one font tag or unsupported tags.
        const fontTags = multiMessage.match(fontTagExpression);
        const parsedTags = multiMessage.match(tagRegex);
        // Begin searching for unsupported tags.
        if (parsedTags) {
            //if (fontTags && fontTags.length > 1) {
            //    console.log("to many font tags");
            //    supported = false;
            //}

            for (i = 0; i < parsedTags.length; i++) {
                if (!supportedTagExpression.test(parsedTags[i])) {
                    supported = false;
                    break;
                }
            }
        }
    } else {
        supported = false;
    }

    return supported;
}

export const getDmsDisplayColor = (opStatus: OpStatus): string => {
    let color = dmsOpStatusColorMap.get(opStatus);
    if (!color) {
        color = dmsOpStatusColorMap.get(OpStatus.NULL)!;
    }
    return color;
}

export const dmsOpStatusColorMap: Map<OpStatus, string> = new Map([
    [OpStatus.Active, "green"],
    [OpStatus.Failed, "red"],
    [OpStatus.Error, "red"],
    [OpStatus.OutOfService, "grey"],
    [OpStatus.NULL, "grey"]
])
